
import { Toaster } from 'react-hot-toast';
import './App.css';
import { Contact } from './components/contacts/Contact';
import { Footer } from './components/footer/Footer';
import GithubCalender from './components/githubCalender/GithubCalender';
import { Nav } from './components/nav/Nav';
import { Portfolio } from './components/portfolio/Portfolio';
import { Skills } from './components/skills/Skills';
import { TopContainer } from './components/topcontainer/TopContainer';
import { Helmet } from 'react-helmet';

function App() {
  return (
    <div className="App">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Vasanth Developer </title>

        <link rel="canonical" href="https://vasanth-dev.com/" />
        <meta
          name="description"
          content="Vasanth Developer - Full-stack developer with expertise in modern web technologies, delivering high-quality web applications and solutions."
        />
      </Helmet>


      <Toaster
        position="bottom-center"
        reverseOrder={false}
      />
      <TopContainer />
      <Nav />
      <Skills />
      <Portfolio />
      <GithubCalender />
      <Contact />
      <Footer />

    </div>
  );
}

export default App;
